import React, { useEffect, useState } from 'react';
import { FrontChatData } from 'src/ReduxStorage/Auth/types';
import { InstitutionSummary } from 'src/ReduxStorage/Institutions/types';
import { LoadJsScript } from 'src/web/components/LoadRemote/LoadJsScript';

declare global {
  interface Window {
    FrontChat: (command: string, attributes: Record<string, unknown>) => void;
  }
}

export interface InstitutionSettingsFrontChatProps {
  institution: InstitutionSummary | null;
  fetchCurrentUserFrontChatDataForInstitution: (
    currentInstitutionPath: string
  ) => Promise<FrontChatData>;
}

export const InstitutionSettingsFrontChat: React.FC<InstitutionSettingsFrontChatProps> = ({
  institution,
  fetchCurrentUserFrontChatDataForInstitution,
}) => {
  const [frontAppData, setFrontAppData] = useState<FrontChatData | null>(null);

  useEffect(() => {
    if (institution && frontAppData === null) {
      fetchCurrentUserFrontChatDataForInstitution(institution.path).then(
        (result) => {
          setFrontAppData(result);
        }
      );
    }
  }, [
    institution,
    fetchCurrentUserFrontChatDataForInstitution,
    frontAppData,
    setFrontAppData,
  ]);

  if (frontAppData === null || !frontAppData.success) {
    return null;
  }

  const { email, userHash, chatId } = frontAppData;

  return (
    <LoadJsScript
      src="https://chat-assets.frontapp.com/v1/chat.bundle.js"
      onLoad={() =>
        // eslint-disable-next-line new-cap
        window.FrontChat('init', {
          chatId,
          useDefaultLauncher: true,
          email,
          userHash,
        })
      }
    />
  );
};
